import { render, staticRenderFns } from "./AssignManagerTable.vue?vue&type=template&id=5c9a5029&scoped=true"
import script from "./AssignManagerTable.vue?vue&type=script&lang=js"
export * from "./AssignManagerTable.vue?vue&type=script&lang=js"
import style0 from "./AssignManagerTable.vue?vue&type=style&index=0&id=5c9a5029&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9a5029",
  null
  
)

export default component.exports